import { z } from 'zod'

import { useEffect } from 'react'

import { useOktaAuth } from '@okta/okta-react'
import { createFileRoute, useNavigate } from '@tanstack/react-router'

const LoginComponent = () => {
  const { oktaAuth, authState } = useOktaAuth()
  const { redirect: to } = Route.useLoaderDeps()
  const navigate = useNavigate()

  useEffect(() => {
    if (!authState) {
      return
    }

    if (authState.isAuthenticated) {
      navigate({ to, replace: true })
    } else {
      oktaAuth.signInWithRedirect({
        originalUri: to,
      })
    }
  }, [oktaAuth, authState?.isAuthenticated, authState, navigate, to])
}

export const Route = createFileRoute('/login')({
  validateSearch: z.object({
    redirect: z.string().catch('/'),
  }),

  loaderDeps: ({ search }) => ({ redirect: search.redirect }),
  component: LoginComponent,
})
